'use strict';

const MODAL_TRANSLATIONS = {
  en: {
    continue: 'RETURN TO THE STORE',
    checkout: 'PROCEED TO CHECKOUT'
  },
  sr: {
    continue: 'POVRATAK U PRODAVNICU',
    checkout: 'ZAVRŠI KUPOVINU'
  }
};

function applyModalOverrides() {
  if (typeof Weglot === 'undefined' || typeof Weglot.getCurrentLang !== 'function') return;

  const currentLang = Weglot.getCurrentLang().split('-')[0].toLowerCase();
  const isEn = (currentLang === 'en');
  
  // check language and set key for translations
  const langKey = isEn ? 'en' : 'sr';

  // translate continue
  const continueBtns = document.querySelectorAll('.tt-modal-addtocart .btn-close-popup.ttmodalbtn');
  continueBtns.forEach(el => {
    if (el.textContent.trim() !== MODAL_TRANSLATIONS[langKey].continue) {
      el.textContent = MODAL_TRANSLATIONS[langKey].continue;
    }
  });

  // translate checkout
  const checkoutBtns = document.querySelectorAll('.tt-modal-addtocart a[href*="checkout"].ttmodalbtn');
  checkoutBtns.forEach(el => {
    if (el.textContent.trim() !== MODAL_TRANSLATIONS[langKey].checkout) {
      el.textContent = MODAL_TRANSLATIONS[langKey].checkout;
    }
  });
}

function triggerOverrideWithDelay() {
  applyModalOverrides();
  setTimeout(applyModalOverrides, 400);
  setTimeout(applyModalOverrides, 1200);
}

function resetTermsCheckboxes() {
  const desktop = document.getElementById('modal-term-conditions-checkbox-desktop');
  const mobile = document.getElementById('modal-term-conditions-checkbox-mobile');

  if (desktop) {
    desktop.checked = false;
    // return disabled on checkout button (desktop)
    const checkoutDesktop = document.querySelector('.tt-modal-addtocart.desctope a[href*="checkout"].ttmodalbtn');
    if (checkoutDesktop) checkoutDesktop.classList.add('disabled');
  }

  if (mobile) {
    mobile.checked = false;
    // return disabled on checkout button (mobile)
    const checkoutMobile = document.querySelector('.tt-modal-addtocart.mobile a[href*="checkout"].ttmodalbtn');
    if (checkoutMobile) checkoutMobile.classList.add('disabled');
  }
}

function initModalCloseObserver() {
  const modal = document.getElementById('modalAddToCartProduct');
  if (!modal) return;

  let hadShowClass = modal.classList.contains('show');

  const modalObserver = new MutationObserver(() => {
    const hasShowClass = modal.classList.contains('show');
    // reset checkboxes only when modal transitions from open to closed state
    if (hadShowClass && !hasShowClass) {
      resetTermsCheckboxes();
    }
    hadShowClass = hasShowClass;
  });

  modalObserver.observe(modal, { attributes: true, attributeFilter: ['class'] });
}

// pageshow to handle back/forward navigation where the modal might be left open in the cached page state
window.addEventListener('pageshow', resetTermsCheckboxes);

document.addEventListener('DOMContentLoaded', () => {
  // reset checkboxes on page load in case modal was left open
  initModalCloseObserver();

  // DOM observer to handle dynamic content changes in the modal
  const observer = new MutationObserver((mutations) => {
    for (let mutation of mutations) {
      if (mutation.addedNodes.length || mutation.type === 'characterData') {
        applyModalOverrides();
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true
  });

  // initial application and event listener for language changes
  if (typeof Weglot !== 'undefined') {
    Weglot.on('languageChanged', triggerOverrideWithDelay);
    applyModalOverrides();
  } else {
    document.addEventListener('weglot:initialized', triggerOverrideWithDelay);
  }
});